<template>
    <div class="tabs-component">
        <ul role="tablist" class="tabs-component-tabs">
            <li role="presentation" 
                v-for="(tab, i) in tabs" 
                :key="i"
                class="tabs-component-tab"
                :class="{ 'is-active': tab.isActive }">
                <a  :href="tab.hash"
                    :aria-controls="tab.hash"
                    :aria-selected="tab.isActive"
                    @click="selectTab(tab, $event)" class="tabs-component-tab-a"
                    role="tab">
                    {{ tab.header }}
                </a>
            </li>
        </ul>
        <div class="tabs-component-panels">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: []
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.tabs[0].isActive = true;
  },
  methods: {
    selectTab(selectedTab, event) {
      event.preventDefault();

      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });

      this.$emit('changed', { tab: selectedTab });
    }
  }
};
</script>
